export default [
  // {
  //   path: '/opening-supply-entry',
  //   name: 'openingSupplyEntry',
  //   component: () =>
  //     import(/*webpackChunkName:'opening'*/
  //     '@/views/opening/openingSupplyEntry/OpeningSupplyEntryList.vue'),
  //   meta: {}
  // },
];
